import { Injectable } from '@angular/core';

import { LassoDynamicFilterCommand } from '../../../../../pages/administration/report-groups/components/report-groups-filter-criteria/report-groups-dynamic-filter/dynamic-filters/lasso-dynamic-filter.component ';

@Injectable()
export class EventsReportGroupModalService implements LassoDynamicFilterCommand {
  private command: () => void = () => undefined;

  execute(): void {
    this.command();
  }

  registerCommand(command: () => void): void {
    this.command = command;
  }
}
